import { useRef, useEffect } from "react";
const useIsMounted = () => {
  const mountedRef = useRef(true);
  useEffect(() => {
    const cleanup = () => {
      mountedRef.current = false;
    };
    return cleanup;
  }, []);
  return () => mountedRef.current;
};
export {
  useIsMounted as default
};
//# sourceMappingURL=use-is-mounted.js.map
